import getConfig from 'next/config';
/**
 * Auto switch env base on Code run on server or local
 * @returns env from ENV variables
 */
export const getEnvVariable = () => {
    const envVariables = getConfig();
    const variables = {
        baseURL: envVariables?.publicRuntimeConfig?.baseURL ||
            'https://api.qa.healthemed.tv/portal-gateway/v1',
        authURL: envVariables?.publicRuntimeConfig?.authURL ||
            'https://saml.auth.qa.healthemed.tv/oauth2/authorize?identity_provider=CharmHealthSandbox&redirect_uri=http://localhost:3000&response_type=CODE&client_id=76fvrjgsot1lvac3cfvt95lp9m',
        origin: envVariables?.publicRuntimeConfig?.origin || 'http://localhost:3000',
        youtubeEmbedURL: envVariables?.publicRuntimeConfig?.youtubeEmbedURL ||
            'https://youtube.com/oembed',
        pendoAPIKey: envVariables?.publicRuntimeConfig?.pendoAPIKey || '0919215c-d19a-4b1c-6b25-0deff2535f8b',
        charmHealthURL: envVariables?.publicRuntimeConfig?.charmHealthURL || 'http://sandbox3.charmtracker.com/loginHome.sas',
        inventracerURL: envVariables?.publicRuntimeConfig?.inventracerURL || 'https://inventory.qa.healthemed.tv',
        isEnabledPendo: envVariables?.publicRuntimeConfig?.isEnabledPendo || false,
        pendoAccountId: envVariables?.publicRuntimeConfig?.pendoAccountId || 'e84f8b6e-ac8f-4143-aa34-645b221705fd',
        pendoAccountName: envVariables?.publicRuntimeConfig?.pendoAccountName || 'CharmHealthClinic',
        sentryEnabled: envVariables?.publicRuntimeConfig?.sentryEnabled || false,
        sentryDSN: envVariables?.publicRuntimeConfig?.sentryDSN || '',
        portalVersion: envVariables?.publicRuntimeConfig?.portalVersion || ''
    };
    return {
        ...variables,
        baseUrlWithoutV1: variables.baseURL.replace('/v1', ''),
        baseUrlForServerSide: envVariables?.publicRuntimeConfig?.baseUrlForServerSide ? envVariables?.publicRuntimeConfig?.baseUrlForServerSide + '/v1' : variables.baseURL,
    };
};
